import React, { Component } from "react";
import cx from "classnames";
import "./Navbar.css";

class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      y: 0
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    // console.log("SCROLL", window.pageYOffset);
    this.setState({
      y: window.pageYOffset
    });
  };

  render() {
    const { children, dark } = this.props;
    const { y } = this.state;

    return (
      <div
        className={cx("Navbar", {
          "Navbar--Shadow": y > 10,
          "Navbar--Dark": dark
        })}
        children={children}
      />
    );
  }
}

// const Navbar = ({ children }) => <div className="Navbar" children={children} />;

export { Navbar };
